import React, { useEffect } from 'react';
import BondDirectory from '@components/BondDirectoryFeature/feature/BondDirectorySearch';
import { formatHomePageDeals } from '@components/Homepage/OpportunitiesCarousel/utils/helpers';
import { isValidResponseEntity } from '@helpers/utils';
import {
    getHomePageConfigurations,
    getOpenConfigurations,
} from '@services/configuration.service';
import { getHomePageDisplayDeals } from '@services/homepage-deals-service';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { HeadTagData } from '@helpers/headTagData';
import { configurationEntityTypes } from '@helpers/enums/configuration-enums';
import { useRouter } from 'next/router';
import { Bounce, toast } from 'react-toastify';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';
import routes from '@helpers/routes';

const BondDirectoryPage = ({ homepageDealsResponse, configuration }) => {
    const router = useRouter();

    useEffect(() => {
        const query = router.query;
        if(query?.error === texts?.invalidIsin) {
            toast.error(texts?.invalidIsinErrorMessage, {
                position: "top-center",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
                className: "isin-error-alert",
            });
            const { error, ...restQuery } = query;
            router.replace({
                pathname: router.pathname,
                query: restQuery,
            }, undefined, { shallow: true });
        };
    }, [router.query]);

    
    return (
        <>
            <NextHeadTag {...HeadTagData[routes.bonds.base]} />
            <BondDirectory
                homepageDealsResponse={homepageDealsResponse}
                configuration={configuration}
            />
        </>
    );
};

export const getStaticProps = async (ctx) => {
    const defaultConfig = {
        type: 'General',
        entityType: 'HomePageBanner',
        value: 'Default',
    };
    const HOME_PAGE_REVALIDATION_CACHE_TIME = parseInt(
        process.env.NEXT_PUBLIC_HOME_PAGE_REVALIDATION_TIME
    );
    try {
        const bondFeatureFlag = await getOpenConfigurations(
            configurationEntityTypes.BOND_DIRECTORY_FEATURE
        );

        if (bondFeatureFlag?.entity?.[0]?.value !== 'true') {
            return {
                notFound: true,
            };
        }

        const [response, homepageDealsResponse] = await Promise.all([
            getHomePageConfigurations(ctx),
            getHomePageDisplayDeals(ctx),
        ]);

        const formattedDeals = {
            entity: isValidResponseEntity(homepageDealsResponse)
                ? formatHomePageDeals(homepageDealsResponse?.entity)
                : [],
            status: homepageDealsResponse?.status,
            message: homepageDealsResponse?.message,
        };

        return {
            props: {
                configuration:
                    !isValidResponseEntity(response) ||
                    response?.entity?.length === 0
                        ? defaultConfig
                        : response?.entity?.[0],
                homepageDealsResponse: formattedDeals,
            },
            revalidate: HOME_PAGE_REVALIDATION_CACHE_TIME,
        };
    } catch (error) {
        return {
            props: {
                configuration: defaultConfig,
                homepageDealsResponse: {
                    entity: [],
                    status: false,
                    message: 'Something went wrong',
                },
            },
            revalidate: HOME_PAGE_REVALIDATION_CACHE_TIME,
        };
    }
};

export default BondDirectoryPage;
